import React from 'react';
import { Button } from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import { TypographySecondary } from '@johnlewispartnership/wtr-ingredients/foundations/typography/TypographySecondary';

import { ChevronLeft } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { trackShoppableSwap } from 'analytics/recipes-tracking';
import type { Promotion } from '@johnlewispartnership/wtr-ingredients/ingredients/ProductPod/types';
import ShoppableHeadingStyles from '../ShoppableHeading/index.scss';
import { SwapProductItem } from './SwapProductItem';
import styles from './index.scss';
import AlternativeProducts from './AlternativeProducts';
import { ProductDataType } from '../ProductGrid';
import { ProductTags } from '../ProductGrid/ShoppablePod';

export interface SwapProductPayload
  extends Omit<ProductDataType, 'lineNumber' | 'brand' | 'categories' | 'promotions'> {
  isSponsored: boolean;
  isNewRecipe: boolean;
  isAllergenUpdate: boolean;
  productUrl?: string;
  thumbnail: string;
  pimsId?: string;
  displayPriceQualifier: string;
  youNeedText?: string;
  displayUOMPrice?: string;
  ingredientId: string;
  conflicts: string[];
  productTags: ProductTags;
  pricing: {
    displayPriceQualifier: string;
    displayUOMPrice: string;
  };
  lineNumber?: string;
  promotions: Promotion[];
}

export interface SwapProductProps {
  shoppableProductIndex: number;
  payload: SwapProductPayload | null;
  closeSwapProduct: () => void;
  recipeId: string;
  setCurrentSwappedProduct: (product: SwapProductPayload) => void;
}

const SwapProduct = ({
  shoppableProductIndex,
  payload,
  closeSwapProduct,
  recipeId,
  setCurrentSwappedProduct,
}: SwapProductProps) => {
  const handleBackButton = () => {
    trackShoppableSwap('back', recipeId, payload?.lineNumber);
    closeSwapProduct();
  };

  return (
    <div className={ShoppableHeadingStyles.modalHeader} data-testid="swap-product">
      <div className={styles.modalHeaderTop}>
        <Button
          theme="secondary"
          onClick={handleBackButton}
          className={styles.modalHeaderBackButton}
        >
          <ChevronLeft
            className={styles.modalHeaderBackButtonIcon}
            size="medium"
            onClick={handleBackButton}
          />{' '}
          Back
        </Button>
        <TypographySecondary
          component="h2"
          font="sebenta"
          size={16}
          className={styles.modalHeaderTopTitle}
        >
          Swap Ingredient
        </TypographySecondary>
        <div className={styles.modalHeaderTopSpacer} />
      </div>
      <div className={ShoppableHeadingStyles.selectedIngredients}>Current Selection</div>

      {payload && (
        <div className={styles.swapContent}>
          <SwapProductItem {...payload} hideSelectButton isCurrentSelection />
          <AlternativeProducts
            pimsId={payload.pimsId}
            lineNumber={payload.lineNumber}
            closeSwapProduct={closeSwapProduct}
            recipeId={recipeId}
            groupId={shoppableProductIndex}
            ingredientId={payload.ingredientId}
            setCurrentSwappedProduct={setCurrentSwappedProduct}
            youNeedText={payload.youNeedText}
          />
        </div>
      )}
    </div>
  );
};

export default SwapProduct;
